import { render } from "./home-topactions.vue?vue&type=template&id=21324b12"
import script from "./home-topactions.js?vue&type=script&lang=js"
export * from "./home-topactions.js?vue&type=script&lang=js"

import "./home-topactions.vue?vue&type=style&index=0&id=21324b12&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__